import { RouteLocation } from "../RouteView/routeViewModel"
import { AddJobsRecord, RouteJob } from "../routingApi"
import { findRouteJobDetails } from "../routingModel"

const ROUTES_URL = 'https://routes.googleapis.com/directions/v2:computeRoutes'

export type GoogleMapsRoutesRequest = {
  origin: GoogleMapsWaypoint,
  destination: GoogleMapsWaypoint,
  intermediates: GoogleMapsWaypoint[],
  travelMode: string,
  optimizeWaypointOrder: boolean,
}

export type GoogleMapsWaypoint = {
  location: GoogleMapsLocation,
  placeId?: string
}

type GoogleMapsLocation = {
  latLng: GoogleMapsLatLng
}

type GoogleMapsLatLng = {
  latitude: number,
  longitude: number
}

const sendGoogleMapsRequest = async (request: GoogleMapsRoutesRequest) => {
  const response = await fetch(ROUTES_URL, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Content-Type': 'application/json',
      'X-Goog-FieldMask': `routes,geocodingResults.intermediates.intermediateWaypointRequestIndex`,
      'X-Goog-Api-Key': (window as any).env.GOOGLE_API_KEY
    }
  });
  return await response.json();
}

export const googleMapsOptimizeRoute = async (startingLocation: RouteLocation, endingLocation: RouteLocation, jobsForCreateRoute: AddJobsRecord[] | undefined, jobsToOptimize: RouteJob[]) => {
  const googleMapsRequest: GoogleMapsRoutesRequest = {
    origin: {
      location: {
        latLng: {
          latitude: startingLocation?.latitude ?? 0,
          longitude: startingLocation?.longitude ?? 0
        }
      }
    },
    destination: {
      location: {
        latLng: {
          latitude: endingLocation?.latitude ?? 0,
          longitude: endingLocation?.longitude ?? 0
        }
      }
    },
    intermediates: jobsToOptimize?.map(x => {
      const job = findRouteJobDetails(x, jobsForCreateRoute);
      return {
        location: {
          latLng: {
            latitude: job?.latitude ?? 0,
            longitude: job?.longitude ?? 0
          }
        }
      };
    }),
    travelMode: 'DRIVE',
    optimizeWaypointOrder: true
  }

  return await sendGoogleMapsRequest(googleMapsRequest)
}